import { DeleteGuestUserAccess } from 'Apollo/mutations/organization/DeleteGuestUserAccess';
import RemoveUsersConfirmation from './RemoveUsersConfirmation';
import useRemoveUsersMutation from './useRemoveUsersMutation';

interface Props {
  selectedUserIds: string[];
  selectAllUserEnabled: boolean;
  selectedUserCount: number;
  userFilter: string | null;
  organizationCode: string;
  onCollapse: () => void;
  onReloadUsers: () => void;
}

const RemoveGuestUsers = (props: Props) => {
  const {
    selectedUserIds,
    selectAllUserEnabled,
    selectedUserCount,
    userFilter,
    organizationCode,
    onCollapse,
    onReloadUsers
  } = props;

  const { loading, onSubmit } = useRemoveUsersMutation<
    DeleteGuestUserAccessData,
    DeleteGuestUserAccessVariables
  >({
    mutation: DeleteGuestUserAccess,
    batchErrorCode: 'E436',
    refetchQueries: ['GetOrganizationGuestUsers'],
    selectedUserCount,
    onCollapse,
    onReloadUsers,
    getVariables: () => ({
      organizationCode,
      personIdentifiers: selectAllUserEnabled ? null : selectedUserIds,
      filter: userFilter
    })
  });

  return (
    <RemoveUsersConfirmation
      selectedUserCount={selectedUserCount}
      loading={loading}
      confirmationMessageId="page.users.action.delete.confirmationGuestUser"
      onSubmit={onSubmit}
      onCollapse={onCollapse}
    />
  );
};

export default RemoveGuestUsers;
